import React from "react";

export default function ComplianceOverview()
{
    const overallCompliance = 68;

    const compliance =
    [
        {
            category: "Fire Safety",
            score: 92
        },
        {
            category: "Legionella",
            score: 71
        },
        {
            category: "Asbestos",
            score: 81
        },
        {
            category: "Lift Inspections",
            score: 54
        },
        {
            category: "Emergency Lighting",
            score: 64
        },
		{
           category: "Legal",
           score: 14
       }
    ];

  
    const getColour = (score) =>
    {
        if(score >= 85)
        {
            return "#4caf50";
        }

        if(score >= 70)
        {
            return "#f4c542";
        }

        return "#e53935";
    };

    return (

        <div
            style={{
                width: "100%",
                height: "100%",

                display: "flex",
                flexDirection: "column"
            }}
        >

            <div
                style={{
                    fontSize: "12px",
                    fontWeight: 500,

                    textTransform: "uppercase",

                    marginBottom: "14px",

                    color: "#222"
                }}
            >
                COMPLIANCE OVERVIEW
            </div>

            <div
                style={{
                    fontSize: "11px",
                    color: "#666",
					marginLeft:'20px',
                    marginBottom: "4px"
                }}
            >
                Overall Compliance
            </div>

            <div
                style={{
                    fontSize: "30px",
                    fontWeight: 700,
					marginLeft:'20px',
					
                    color: "#222",

                    marginBottom: "8px"
                }}
            >
                {overallCompliance}%
            </div>

            <div
                style={{
                    height: "6px",
					marginLeft:'20px',
					marginRight:'20px',
                    borderRadius: "3px",

                    background: "#e9edf4",

                    overflow: "hidden",

                    marginBottom: "14px"
                }}
            >

                <div
                    style={{
                        width: overallCompliance + "%",
                        height: "100%",

                        background: "#4caf50"
                    }}
                />

            </div>

            <table
                style={{
                    width: "100%",

                    borderCollapse: "collapse",

                    marginBottom: "12px"
                }}
            >

                <tbody>

                    {
                        compliance.map(
                            (
                                item,
                                index
                            ) => (

                                <tr
                                    key={index}
                                >

                                    <td
                                        style={{
                                            padding: "5px 20px",

                                            fontSize: "13px",

                                            color: "#444"
                                        }}
                                    >
                                        {item.category}
                                    </td>

                                    <td
                                        style={{
                                            textAlign: "right",
											paddingRight:'20px',
                                            fontWeight: 600,

                                            color:
                                                getColour(item.score),

                                            fontSize: "13px"
                                        }}
                                    >
                                        {item.score}%
                                    </td>

                                </tr>

                            ))
                    }

                </tbody>

            </table>

           

        </div>

    );

}